import * as React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@mui/material/';
import { useLanguageStore } from '../store/useLanguageStore';

interface PropsType {
  onClose: () => void;
  open: boolean;
  token: { created_at: number; id: string; name: string; revoked: boolean };
  revokeToken: () => void;
}

const DialogType1: React.FC<PropsType> = ({
  onClose,
  open,
  token,
  revokeToken,
}) => {
  // const { onClose, open, token, revokeToken } = props;
  const { languagePack } = useLanguageStore();
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': { width: '70%', maxWidth: 'max(31.25vw, 600px)' },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        {languagePack && languagePack.deleteComponent.dialogtitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: 1 }}>
          <span className="token-name">{token.name}</span>
          {languagePack && languagePack.deleteComponent.dialogcontenttext}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={handleClose}>
          {languagePack && languagePack.deleteComponent.btncancel}
        </Button>
        <Button variant="contained" color="error" onClick={revokeToken}>
          {languagePack && languagePack.deleteComponent.btndelete}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogType1;
